import { createGenerateClassName } from '@material-ui/core/styles';

const prefix = 'micros';
const GENERATE_ID_KEY = 'SGmaterialUIGenerateId';

const materialUIConfiguration = {
    seed: prefix,
};

export function getMaterialUIConfiguration() {
    const generateId = createGenerateClassName(materialUIConfiguration);

    window[GENERATE_ID_KEY] = generateId;

    return generateId;
}
